import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  NewsletterForm,
  NewsletterFormProps,
} from '../../../components/newsletter_form/newsletter_form';
import { useLocalStorage } from '../../../hooks/use_local_storage';
import { StorageKeys } from '../../../lib/local_storage';
import { hasAccessToken } from '../../../redux/auth';
import EnvelopeIcon from './envelope.png';
import styles from './get_started_newsletter_modal.less';

export const GetStartedNewsletterModal = (props: { context?: NewsletterFormProps['context'] }) => {
  const { context } = props;
  const isLoggedIn = useSelector(hasAccessToken);
  const [modalOpen, setModalOpen] = useState(false);

  const [getStartedNewsletterClosed, setGetStartedNewsletterClosed] = useLocalStorage(
    StorageKeys.getStartedNewsletterClosed,
    false
  );

  useEffect(() => {
    setTimeout(() => {
      if (!getStartedNewsletterClosed && !isLoggedIn) {
        setModalOpen(true);
      }
    }, 5000);
  }, []);

  const handleGetStartedModal = () => {
    setGetStartedNewsletterClosed(true);
    setModalOpen(false);
  };

  return (
    <Modal
      centered
      open={modalOpen}
      onCancel={() => {
        setModalOpen(false);
        setGetStartedNewsletterClosed(true);
      }}
      className={styles.modalCard}
    >
      <section className={styles.upperSection}>
        <div className={styles.header}>
          <img src={EnvelopeIcon} alt="envelope-icon" />
          <h4 className={styles.headerMobile}>Get 10% Off Your First Order</h4>
        </div>
        <div className={styles.signupText}>
          <h4>Get 10% Off Your First Order</h4>
          <p>
            Signup for the Omnia Fishing newsletter and get 10% off your first order. Join over 100k
            anglers who receive our newsletter with curated articles, reviews and exclusive offers
            personalized to your local area.
          </p>
        </div>
      </section>
      <section>
        <NewsletterForm
          context={context ?? 'get_started_modal'}
          onSuccess={handleGetStartedModal}
        />
      </section>
    </Modal>
  );
};
